import { Component } from '@angular/core';

@Component({
  selector: 'ds-registration',
  templateUrl: './registration.component.html',
  styleUrl: './registration.component.scss'
})
export class RegistrationComponent {

}
